export const AUDIO_TYPE = 2;
export const VIDEO_TYPE = 1;